import React, { useState, useEffect } from 'react';
import styles from './Footer.module.css';
import { FaFacebookF, FaTwitter, FaLinkedin, FaWhatsapp, FaInstagram, FaYoutube } from "react-icons/fa";
import { db } from '../../firebase-config';
import { doc, getDoc } from 'firebase/firestore';
import { useLocation } from 'react-router-dom';

function Footer() {
    const [miscellaneousContent, setMiscellaneousContent] = useState({
        affiliatedRituals: '',
        copyright: '',
        termsOfUse: ''
    });
    const [isLoading, setIsLoading] = useState(true);
    const location = useLocation(); // Add this to detect navigation

    // Fetch miscellaneous content from Firestore
    const fetchMiscellaneous = async () => {
        try {
            setIsLoading(true);
            const docRef = doc(db, 'siteContent', 'miscellaneous');
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                setMiscellaneousContent({
                    affiliatedRituals: data.affiliatedRituals || '',
                    copyright: data.copyright || '',
                    termsOfUse: data.termsOfUse || ''
                });
            } else {
                setMiscellaneousContent({
                    affiliatedRituals: '',
                    copyright: '',
                    termsOfUse: ''
                });
            }
        } catch (error) {
            console.error('Error fetching miscellaneous content:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMiscellaneous();
        const interval = setInterval(fetchMiscellaneous, 30000);
        return () => clearInterval(interval);
    }, [location.pathname]); // Re-fetch when location changes

    // Social media click handlers
    const handleSocialClick = (platform) => {
        // TODO: Add actual social media URLs here
        // Example: window.open('https://facebook.com/yourpage', '_blank');

        switch(platform) {
            case 'Facebook':
                window.open('https://facebook.com/yourpage', '_blank');
                break;
            case 'Instagram':
                window.open('https://instagram.com/yourpage', '_blank');
                break;
            case 'Twitter':
                window.open('https://twitter.com/yourpage', '_blank');
                break;
            case 'WhatsApp':
                window.open('https://wa.me/yournumber', '_blank');
                break;
            case 'LinkedIn':
                window.open('https://linkedin.com/company/yourcompany', '_blank');
                break;
            case 'YouTube':
                window.open('https://youtube.com/yourchannel', '_blank');
                break;
        }

    };

    return (
        <div className={styles.footerSection}>
            {/* Debug refresh button removed for production */}
            <div className={styles.footer}>
                <div className={styles.footerBoxContainer}>
                    <div className={styles.footerBox}>
                        <h3>Affiliated Ritual</h3>
                        <div className={styles.footerBanner}></div>
                        {isLoading ? (
                            <p>Loading content...</p>
                        ) : miscellaneousContent.affiliatedRituals ? (
                            <div 
                                dangerouslySetInnerHTML={{ __html: miscellaneousContent.affiliatedRituals }}
                                className={styles.footerContent}
                            />
                        ) : null}
                    </div>
                    <div className={styles.footerBox}>
                        <h3>Useful Links</h3>
                        <div className={styles.footerBanner}></div>
                        <a href="#package">Products </a>
                        <a href="/teammember?action=register">Become a partner</a>
                        <a href="/trainer?action=register">Become a trainer</a>
                    </div>

                    <div className={styles.footerBox}>
                        <h3>Our Company</h3>
                        <div className={styles.footerBanner}></div>
                        <a href="contact-us">Contact Us</a>
                        <a href="disclaimer">Disclaimer</a>
                        <a href="tnc">Terms and Conditions</a>
                        <a href="refund-policy">Refund Policy</a>
                    </div>

                    <div className={styles.footerBox}>
                        <h3>Get In Touch</h3>
                        <div className={styles.footerBanner}></div>
                        <p>Like, Share, Follow and Subscribe.
                            If you love Affiliate Ritual</p>

                        <div className={styles.footerMedia}>
                            <a 
                                href="#" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialClick('Facebook');
                                }}
                                className={styles.socialLink}
                                title="Follow us on Facebook"
                            >
                                <FaFacebookF />
                            </a>
                            <a 
                                href="#" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialClick('Instagram');
                                }}
                                className={styles.socialLink}
                                title="Follow us on Instagram"
                            >
                                <FaInstagram />
                            </a>
                            <a 
                                href="#" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialClick('Twitter');
                                }}
                                className={styles.socialLink}
                                title="Follow us on Twitter"
                            >
                                <FaTwitter />
                            </a>
                            <a 
                                href="#" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialClick('WhatsApp');
                                }}
                                className={styles.socialLink}
                                title="Contact us on WhatsApp"
                            >
                                <FaWhatsapp />
                            </a>
                            <a 
                                href="#" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialClick('LinkedIn');
                                }}
                                className={styles.socialLink}
                                title="Connect with us on LinkedIn"
                            >
                                <FaLinkedin />
                            </a>
                            <a 
                                href="#" 
                                onClick={(e) => {
                                    e.preventDefault();
                                    handleSocialClick('YouTube');
                                }}
                                className={styles.socialLink}
                                title="Subscribe to our YouTube channel"
                            >
                                <FaYoutube />
                            </a>
                        </div>

                    </div>
                </div>

                <div className={styles.footerCredit}>
                    <div>
                        {isLoading ? (
                            <p>Loading...</p>
                        ) : miscellaneousContent.copyright ? (
                            <div 
                                dangerouslySetInnerHTML={{ __html: miscellaneousContent.copyright }}
                                className={styles.footerContent}
                            />
                        ) : null}
                    </div>

                    <div>
                        {isLoading ? (
                            <p>Loading...</p>
                        ) : miscellaneousContent.termsOfUse ? (
                            <div 
                                dangerouslySetInnerHTML={{ __html: miscellaneousContent.termsOfUse }}
                                className={styles.footerContent}
                            />
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer;
